export default __webpack_public_path__ + "static/media/free5.b2af034a.svg";